<div class="card-product -title">
  <div *ngIf="subtitle" class="-subtitle -fontDisplayThin">{{subtitle}}</div>
  <h3>{{title}}</h3>
</div>
<ng-content></ng-content>